import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-collapsible-fieldset',
  templateUrl: './collapsible-fieldset.component.html'
})
export class CollapsibleFieldsetComponent implements OnInit {

  @Input() label: string;
  @Input() subform: FormControl;
  @Input() isOpen: boolean;

  isValid: boolean;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.isValid = this.subform.status === 'VALID';
    this.subform.statusChanges.subscribe(status => {
      this.isValid = status === 'VALID';
    });
  }

}
